<template>
  <div class="program-list-table" v-loading="loading">
    <div class="program-list-table__header">
      <div class="program-list-table__header__name">
        <span v-text="!isPropertyNBA ? fields.name.label : i18n('entities.season.fields.name')"></span>
      </div>
      <div class="program-list-table__header__type">
        <span v-text="!isPropertyNBA ? fields.type.label : i18n('entities.season.fields.type')"></span>
      </div>
      <div class="program-list-table__header__actions"></div>
    </div>

    <div class="program-list-table__body">
      <el-row :gutter="5" :key="row.id" v-for="row in rows">
        <div class="program-list-table__body__row">
          <el-card class="program-list-table__body__row--shadow">
            <div class="program-list-table__body__row__card__program">

              <!-- Name -->
              <div class="program-list-table__body__row__card__program__name">
                {{ presenter(row, 'name') }}
              </div>

              <!-- Type -->
              <div
                class="program-list-table__body__row__card__program__type"
                v-text="presenter(row, 'type')"
              />

              <!-- Actions -->
              <div class="program-list-table__body__row__card__program__actions">
                <!-- Edit -->
                <div class="program-list-table__body__row__card__program__actions__edit">
                  <el-button @click="handleClickEdit(row)" circle icon="icon-pen" />
                </div>
                <!-- Destroy -->
                <div class="program-list-table__body__row__card__program__actions__destroy">
                  <el-button
                    v-if="hasPermissionToDestroy"
                    :disabled="destroyLoading"
                    @click="doDestroyWithConfirm(row)"
                    circle
                    icon="icon-trash"
                  />
                </div>
              </div>
            </div>
          </el-card>

          <!-- Subprograms -->
          <el-collapse>
            <el-collapse-item :disabled="row.subprograms.length === 0">
              <!-- Header -->
              <template slot="title">
                <div class="program-list-table__body__row__card__subprograms__header__title">
                  <app-i18n :code="!isPropertyNBA ? 'entities.category.label.many' : 'programs.league.menu'" />
                </div>
                <div class="program-list-table__body__row__card__subprograms__header__count">({{row.subprograms.length}})</div>
              </template>
              <template class="button-add-subprogram" slot="title">
                <div class="program-list-table__body__row__card__subprograms__header__btn__plus">
                  <el-button @click="handleClickNewSubprogram(row)" circle icon="el-icon-plus"></el-button>

                  <el-dialog :visible.sync="subprogram.modal.visible" width="90%"></el-dialog>
                  <router-view></router-view>
                </div>
              </template>

              <!-- Body -->
              <div class="program-list-table__body__row__card__subprograms__body">
                <app-subprogram-list-table
                  :handleClickEditFn="handleClickEditSubprogram"
                  :manage="{...currentManage, program: row, path:path}"
                  :rowsLocal="row.subprograms"
                  :typeProgram="row.type"
                  v-if="row.subprograms && row.subprograms.length != 0"
                />
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { ProgramModel } from '@modules/program/program-model';
import { mapGetters, mapActions } from 'vuex';
import { ProgramPermissions } from '@modules/program/program-permissions';
import { i18n } from '@shared/i18n';
import SubprogramListTable from '@modules/subprogram/components/subprogram-list-table.vue';

const { fields } = ProgramModel;

export default {
  name: 'app-program-list-table',

  props: {
    simple: Boolean,
    maxItems: Number,
  },

  manage: {
    type: Object,
  },

  data() {
    return {
      path: '/program/list',
      activeCardSubprogram: {},
      subprogram: {
        modal: {
          visible: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      allRows: 'program/list/rows',
      count: 'program/list/count',
      loading: 'program/list/loading',
      pagination: 'program/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'program/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
      currentManage: 'auth/manage/currentManage',
      activeTab: 'layout/headerTabs/activeTab',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    rows() {
      if (!this.maxItems) return this.allRows;
      return this.allRows.slice(0, this.maxItems);
    },

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new ProgramPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new ProgramPermissions(this.currentUser)
        .destroy;
    },
    fields() {
      return fields;
    },
    managetoProgram() {
      if (this.manage) {
        return this.manage;
      } else {
        return this.currentManage;
      }
    },
    SubprogramLabel() {
      if (this.typeProgram === 'club') {
        return i18n(`entities.category.label.one`);
      } else {
        return i18n(`entities.category.label.one`);
      }
    },

    isAdmin() {
      if (this.currentUser && this.currentUser.isAdmin) {
        return this.currentUser.isAdmin;
      }
      return false;
    },

    // isDisabledRemove(){
    //   const isDisabledForNormalUsers = process.env.VUE_APP_DISABLE_REMOVE_BUTTON_PROGRAM_NORMAL_USERS === 'true';
    //   return isDisabledForNormalUsers;
    // }
  },

  methods: {
    ...mapActions({
      doChangeSort: 'program/list/doChangeSort',
      doChangePaginationCurrentPage:
        'program/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'program/list/doChangePaginationPageSize',
      doMountTable: 'program/list/doMountTable',
      doDestroy: 'program/destroy/doDestroy',
      doChangeFilter: 'program/list/doChangeFilter',
    }),

    presenter(row, fieldName) {
      return ProgramModel.presenter(row, fieldName);
    },
    isActiveCardSubprogram({ id }) {
      return this.activeCardSubprogram[id] == true;
    },
    async doDestroyWithConfirm({ id }) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy({
          id,
          manage: this.managetoProgram,
        });
      } catch (error) {
        // no
      }
    },

    handleClickEdit({ id, type }) {
      this.$router.push({
        name: `programEdit`,
        params: {
          id: id,
          manage: this.managetoProgram,
          type: type,
        },
      });
    },

    handleClickNewSubprogram(program) {
      this.$router.push({
        name: 'programSubprogramNew',
        params: {
          propertyId: this.currentManage.property.id,
          subpropertyId: this.currentManage.subproperty.id,
          programId: program.id,
          programType: program.type,
        },
      });
    },

    handleClickEditSubprogram(subprogram, manageInput) {
      this.$router.push({
        name: 'programSubprogramEdit',
        params: {
          id: subprogram.id,
          propertyId: manageInput.property.id,
          subpropertyId: manageInput.subproperty.id,
          programId: manageInput.program.id,
          programType: manageInput.program.type,
        },
      });
    },

    i18n(code) {
      return i18n(code);
    },
  },
  components: {
    [SubprogramListTable.name]: SubprogramListTable,
  },
  watch: {
    activeTab(newValue) {
      this.doChangeFilter({ type: newValue });
    },
  },
};
</script>

<style>
.program-list-table {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 5% 90% 5%;
  grid-template-areas:
    '. table_header .'
    '. table_body .';
}
/* HEADER */
.program-list-table__header {
  padding: 40px 24px 8px;
  color: #c5c5c5;
  grid-area: table_header;
  align-self: stretch;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: 'header_name header_type header_actions ';
}
.program-list-table__header__name {
  grid-area: header_name;
}
.program-list-table__header__type {
  grid-area: header_type;
}
/* BODY */
.program-list-table__body {
  grid-area: table_body;
  align-self: stretch;
}

.program-list-table__body__row {
  margin-bottom: 40px;
}
/* PROGRAM */
.program-list-table__body__row__card__program {
  margin-bottom: 8px;
  margin-top: 1em;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: 'body_name body_type body_actions';
  align-items: center;
  padding-left: 8px;
}
.program-list-table__body__row__card__program__name {
  grid-area: body_name;
  font-weight: 600;
  font-size: 18px;
}
.program-list-table__body__row__card__program__type {
  grid-area: body_type;
}

/* ACTIONS */
.program-list-table__body__row__card__program__actions {
  grid-area: body_actions;
  place-self: end;
  display: grid;
  grid-template-columns: 50px 50px;
  grid-template-areas: 'actions__edit actions__destroy';
}
.program-list-table__body__row__card__program__actions__edit {
  grid-area: actions__edit;
}
.program-list-table__body__row__card__program__actions__destroy {
  grid-area: actions__destroy;
}

/* SUBPROGRAMS */
.program-list-table__body__row__card__subprograms {
  margin-top: 8px;
}
.program-list-table__body__row__card__subprograms__header {
  display: grid;
  grid-template-columns: 50px auto 50px;
  grid-template-areas: 'subprograms__header__arrow  subprograms__header__title subprograms__header__plus';
}
.program-list-table__body__row__card__subprograms__header__btn__arrow {
  grid-area: subprograms__header__arrow;
}
.program-list-table__body__row__card__subprograms__header__btn__arrow
  > .el-button.el-button--default.is-circle {
  background: #ffffff;
}
.program-list-table__body__row__card__subprograms__header__title {
  grid-area: subprograms__header__title;
  align-self: stretch;
  font-size: 18px;
  font-weight: 300;
}
.program-list-table__body__row__card__subprograms__header__count {
  grid-area: subprograms__header__count;
  align-self: left;
}
.program-list-table__body__row__card__subprograms__header__btn__plus {
  grid-area: subprograms__header__plus;
  align-self: center;
}
.program-list-table__body__row__card__subprograms__header__btn__plus
  > .el-button.el-button--default.is-circle {
  background: #2acccc;
  color: #ffffff;
}
.program-list-table__body__row__card__subprograms__header__btn__plus
  > .el-button.el-button--default.is-circle:hover {
  background: #2acccc;
  color: #ffffff;
}

.program-list-table .el-collapse {
  border: none;

  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  margin-top: 8px;
  background-color: #fff;
  color: #404040;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  padding: 20px;
}
.program-list-table .el-collapse-item__header.is-active {
  border-bottom-color: transparent;
}

.program-list-table .el-collapse-item__header {
  display: grid !important;
    grid-template-columns: 50px auto 10px 1fr 50px;
  grid-template-areas: 'subprograms__header__arrow subprograms__header__title . subprograms__header__count subprograms__header__plus';

  align-items: center;
  line-height: 48px;
  font-size: 18px;
  font-weight: 300;
  color: #404040;
  background: none;
  cursor: pointer;
  border-bottom: none;
  transition: border-bottom-color 0.3s;
  outline: 0;
}

.program-list-table .el-collapse-item__arrow.is-active {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.program-list-table .el-collapse-item__arrow {
  margin: 0 20px 0 auto;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  font-weight: 300;
  grid-area: subprograms__header__arrow;
}

.program-list-table .el-collapse-item__wrap {
  border-bottom: none;
}

.program-list-table .el-collapse-item__header.focusing:focus:not(:hover) {
  color: #404040;
}

.program-list-table__body__row--shadow {
  border: none !important;
  background-color: #ffffff;
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05) !important;
  display: flex;
  align-items: center;
}

.program-list-table .el-card__body {
  width: 100%;
}
</style>
